<div class="container">
  <markdown ngPreserveWhitespaces class="container-xxl bd-gutter mt-3 my-md-4 bd-layout" [src]="myDoc">
  </markdown>
</div>

